import {classNames} from "shared/lib/classNames/classNames";
import cls from "./ArrowLink.module.scss";
import {ReactComponent as ArrowButton} from "shared/assets/icons/ArrowButtonsvg.svg";
import {AppLink} from "shared/ui/AppLink/AppLink";

export enum ArrowLinkTheme {
    DOWN = "down",
}

interface ArrowLinkProps {
    className?: string;
    href?: string;
    onClick?: () => void;
    theme?: ArrowLinkTheme;
    color?: string;
}

const ArrowLink = ({className, href , onClick, theme, color}: ArrowLinkProps) => {
    if (href) {
        return (
            <div className={classNames(cls.ArrowLink, {}, [className])} onClick={() => window.location.href = `#${href}`}>
            <div className={classNames(cls.ArrowLink__link, {}, [theme ? cls[theme] : undefined])}>
                <ArrowButton fill={color}/>
            </div>
            </div>
        )
    }
    return (
        <AppLink onClick={onClick} to={'/'} className={classNames(cls.ArrowLink, {}, [className])}>
            <div className={classNames(cls.ArrowLink__link, {}, [theme ? cls[theme] : undefined])}>
                <ArrowButton fill={color} />
            </div>
        </AppLink>
    )
};

export default ArrowLink;

